module.exports = __webpack_public_path__ + "static/img/enterprise-gz.70da45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprises/enterprise-gz.png
// module id = Mf+0
// module chunks = 52